class LinkSelect extends HTMLElement {

  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    const select = this.querySelector('.js-link-select');

    select.addEventListener('change', () => {
      const url = select.value;
      window.location.href = url;
    });
  }
}

customElements.define('link-select', LinkSelect);
